Replaces an existing position opening's person contacts.
